(function () {
  'use strict';

  var STORAGE_KEY = 'hora_cart_urls';
  var COUNT_KEY = 'hora_cart_count';
  var VARIANTS_KEY = 'hora_cart_variant_ids';

  /*
   * Shown only when Shopify gives no reason of its own. Editable under
   * Theme settings > Cart; see layout/theme.liquid for where it is passed in.
   */
  var CART_ERROR_FALLBACK =
    (window.HORA_CART_STRINGS && window.HORA_CART_STRINGS.error) ||
    'Er is iets misgegaan. Probeer het opnieuw.';


  var drawer = document.getElementById('cart-drawer');
  var backdrop = document.getElementById('cart-backdrop');
  var closeBtn = document.getElementById('cart-drawer-close');
  var continueBtn = document.getElementById('cart-continue');
  var itemsEl = document.getElementById('cart-items');
  var emptyEl = document.getElementById('cart-empty');
  var footerEl = document.getElementById('cart-drawer-footer');
  var subtotalEl = document.getElementById('cart-subtotal');
  var totalEl = document.getElementById('cart-total');
  var countBadge = document.getElementById('cart-count');
  var toggleBtn = document.getElementById('cart-toggle');
  var discountRowEl = document.getElementById('cart-discount-row');
  var discountLabelEl = document.getElementById('cart-discount-label');
  var discountValueEl = document.getElementById('cart-discount');

  /*
   * The default label is read out of the markup rather than hardcoded, because
   * the markup already carries the merchant's own wording from
   * Theme settings > Cart. See snippets/cart-drawer.liquid.
   */
  var DISCOUNT_LABEL =
    (discountLabelEl && discountLabelEl.textContent.trim()) || 'Korting';

  if (!drawer) return;



  var cart = null;


  /*
   * Dutch formatting: dot for thousands, comma for decimals, no space after the
   * comma \u2014 4683500 becomes "\u20AC 46.835,00".
   *
   * This used to insert ", " as the decimal separator, producing "\u20AC 46.835, 00".
   * The split/join around that space is gone with it.
   */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var pieces = amount.split('.');
    var whole = pieces[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '\u20AC ' + whole + ',' + pieces[1];
  }


  /*
   * ── Which reduction is shown, and in what order ───────────────────────────
   *
   * Three separate things can lower a price in this store. Only ONE is ever
   * displayed, and they rank like this:
   *
   *   1. A native Shopify discount — an automatic discount or a discount code.
   *      Shopify applies these at the cart, so this file is the only place they
   *      can be seen. Liquid does not expose per-product discount rules, which
   *      is why product pages and cards cannot show them at all.
   *
   *   2. Discounty. Its Bulk price editor writes `price` and `compare_at_price`
   *      straight onto the variant, so from the theme's point of view it is
   *      indistinguishable from (3) — same field, same rendering.
   *
   *   3. A compare-at price typed in by hand in admin.
   *
   * Because (2) and (3) are literally the same field, their relative order
   * cannot be — and does not need to be — expressed in code. (1) outranks both:
   * when a line carries a native discount, no compare-at and no demo was-price
   * is drawn beside it. That is the "never combine" rule, enforced in
   * itemPriceHtml() below.
   *
   * The cart is also the only surface where (2) and (3) are invisible: the Cart
   * AJAX API does not return compare_at_price. So in practice the drawer shows
   * rung 1 or nothing, and the product pages show rung 2/3 or nothing. The two
   * can never appear together, on any surface.
   */

  /* Names of the discounts applied to one line, e.g. ["Test"]. */
  function lineDiscountTitles(item) {
    var allocations = (item && item.line_level_discount_allocations) || [];
    return allocations
      .map(function (a) {
        return a && a.discount_application ? a.discount_application.title : '';
      })
      .filter(function (title) { return !!title; });
  }

  /* Did Shopify actually reduce this line? */
  function hasLineDiscount(item) {
    if (!item) return false;
    return typeof item.original_line_price === 'number' &&
      typeof item.final_line_price === 'number' &&
      item.original_line_price > item.final_line_price;
  }

  /*
   * The price block for one line. A discounted line shows the amount charged,
   * the original struck through, and the discount's name underneath, so a lower
   * number than the product page is always explained.
   */
  function itemPriceHtml(item) {
    if (hasLineDiscount(item)) {
      var titles = lineDiscountTitles(item);
      return '<span class="cart-drawer__item-price">' +
        formatMoney(item.final_line_price) +
        '<span class="cart-drawer__item-old-price">' +
        formatMoney(item.original_line_price) +
        '</span></span>' +
        (titles.length
          ? '<span class="cart-drawer__item-discount">' +
            escapeHtml(titles.join(', ')) + '</span>'
          : '');
    }

    /* No native discount, so the demo was-price may have its turn. */
    return '<span class="cart-drawer__item-price">' +
      formatMoney(item.final_line_price) +
      demoOldPrice(item.final_line_price) +
      '</span>';
  }

  /*
   * Footer discount row. Names every discount Shopify applied, line-level and
   * cart-level, and hides itself when there are none.
   */
  function renderDiscountRow(data) {
    if (!discountRowEl || !discountValueEl) return;

    /*
     * Derived by subtraction, not read from `total_discount`.
     *
     * total_discount reports order-level discounts. An "Amount off products"
     * discount is line-level, so it never reaches that field and the row would
     * stay hidden on the very discount type this store uses. The /cart page had
     * exactly that bug. What the shopper saves is the difference between the
     * two totals, whichever bucket Shopify files the discount under.
     */
    var originalTotal = typeof data.original_total_price === 'number'
      ? data.original_total_price
      : data.total_price;
    var total = originalTotal - data.total_price;

    if (total <= 0) {
      discountRowEl.hidden = true;
      return;
    }

    var titles = [];
    (data.items || []).forEach(function (item) {
      lineDiscountTitles(item).forEach(function (title) {
        if (titles.indexOf(title) === -1) titles.push(title);
      });
    });
    (data.cart_level_discount_applications || []).forEach(function (a) {
      if (a && a.title && titles.indexOf(a.title) === -1) titles.push(a.title);
    });

    if (discountLabelEl) {
      discountLabelEl.textContent = titles.length
        ? DISCOUNT_LABEL + ' · ' + titles.join(', ')
        : DISCOUNT_LABEL;
    }
    discountValueEl.textContent = '−' + formatMoney(total);
    discountRowEl.hidden = false;
  }


  /*
   * Placeholder was-price for the cart — rung 2/3 above — used only by the
   * "Sale preview (demo only)" theme setting. Shopify's Cart AJAX API does not
   * expose compare_at_price, so a genuine was-price cannot be shown here; this
   * is purely for demonstrating the layout. Returns '' when the setting is off,
   * which is the default. Never called for a line that carries a native
   * discount.
   */
  function demoOldPrice(cents) {
    var cfg = window.HORA_DEMO_PRICING;
    if (!cfg || !cfg.enabled) return '';
    var pct = parseFloat(cfg.percent);
    if (!pct || pct <= 0) return '';
    var was = Math.round(cents * (1 + pct / 100));
    if (was <= cents) return '';
    var off = Math.round(((was - cents) / was) * 100);
    /* Same .discount-badge component as the cards and product pages —
       see snippets/discount-badge.liquid. Styles are in theme-global.css. */
    return '<span class="cart-drawer__item-old-price">' + formatMoney(was) + '</span>';
    //  + (off > 0 ? '<span class="discount-badge discount-badge--inline">' + off + '%</span>' : '');
  }


  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /** Strip query string so /products/foo?variant=123 → /products/foo */
  function basePath(url) {
    return url ? url.split('?')[0] : '';
  }

  function saveCartToStorage(data) {
    try {
      var paths = (data.items || []).map(function (item) { return basePath(item.url); });
      var unique = paths.filter(function (p, i) { return paths.indexOf(p) === i; });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
      localStorage.setItem(COUNT_KEY, String(data.item_count || 0));
      var variantIds = (data.items || []).map(function (item) { return String(item.variant_id); });
      localStorage.setItem(VARIANTS_KEY, JSON.stringify(variantIds));
    } catch (e) { }
  }

  function getCartUrlsFromStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.classList.add('cart-open');
    if (window.lenis) window.lenis.stop();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    if (window.lenis) window.lenis.start();
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });


  function updateBadge(count) {
    if (!countBadge) return;
    if (count > 0) {
      countBadge.textContent = count;
      countBadge.classList.add('is-visible');
    } else {
      countBadge.classList.remove('is-visible');
    }
  }


  /*
   * Turn a failed cart response into a message worth showing.
   *
   * Shopify replies to a rejected /cart/add.js or /cart/change.js with
   * { status: 422, message: "...", description: "..." } — for example when the
   * requested quantity exceeds available stock. `description` is the
   * shopper-facing sentence, so it is preferred.
   */
  function cartErrorMessage(payload) {
    if (payload && typeof payload === 'object') {
      if (payload.description) return payload.description;
      if (payload.message) return payload.message;
    }
    return CART_ERROR_FALLBACK;
  }

  /* Is this actually a cart, or an error payload? */
  function isCartPayload(data) {
    return !!data && typeof data === 'object' &&
      typeof data.item_count !== 'undefined' &&
      Object.prototype.hasOwnProperty.call(data, 'items');
  }

  function clearCartError() {
    var existing = document.getElementById('cart-drawer-error');
    if (existing) existing.remove();
  }

  /*
   * Show the problem inside the drawer and open it, so the shopper is told why
   * nothing happened instead of being left guessing.
   */
  function showCartError(message) {
    clearCartError();
    if (!itemsEl || !itemsEl.parentNode) return;

    var el = document.createElement('div');
    el.className = 'cart-drawer__error';
    el.id = 'cart-drawer-error';
    el.setAttribute('role', 'alert');
    el.textContent = message || CART_ERROR_FALLBACK;
    itemsEl.parentNode.insertBefore(el, itemsEl);

    openDrawer();

    window.setTimeout(function () {
      if (el.parentNode) el.remove();
    }, 8000);
  }

  function renderCart(data) {
    /*
     * Guard: never render anything that is not a cart.
     *
     * A rejected request returns an error object with no `items`, and this
     * function used to accept it — clearing the list, showing the empty state
     * and writing the error object to `cart` and to localStorage. Adding more
     * than the available stock therefore appeared to wipe the cart, even though
     * Shopify still held it. The cart is left untouched instead.
     */
    if (!isCartPayload(data)) {
      console.warn('[cart] Ignoring non-cart response:', data);
      return;
    }

    clearCartError();

    cart = data;
    updateBadge(data.item_count);
    saveCartToStorage(data);
    syncCardButtonStates();

    if (!data.items || data.items.length === 0) {
      itemsEl.innerHTML = '';
      emptyEl.style.display = '';
      footerEl.style.display = 'none';
      return;
    }

    emptyEl.style.display = 'none';
    footerEl.style.display = '';

    var html = '';
    data.items.forEach(function (item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.[^.]+)$/, '_160x160_crop_center$1')
        : '';
      var variantTitle = item.variant_title || '';

      html +=
        '<div class="cart-drawer__item" data-line-key="' + item.key + '">' +
        '  <div class="cart-drawer__item-image">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
        '  </div>' +
        '  <div class="cart-drawer__item-details">' +
        '    <p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
        (variantTitle ? '<p class="cart-drawer__item-variant">' + escapeHtml(variantTitle) + '</p>' : '') +
        itemPriceHtml(item) +
        '  </div>' +
        '  <div class="cart-drawer__item-actions">' +
        '    <button class="cart-drawer__item-remove" data-remove-key="' + item.key + '" aria-label="Verwijderen">' +
        '      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '        <path d="M15 1L1 15M1 1L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '      </svg>' +
        '    </button>' +
        '    <div class="cart-drawer__qty">' +
        '      <button class="cart-drawer__qty-btn" data-qty-change="-1" data-qty-key="' + item.key + '" aria-label="Minder">&minus;</button>' +
        '      <span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
        '      <button class="cart-drawer__qty-btn" data-qty-change="1" data-qty-key="' + item.key + '" aria-label="Meer">&plus;</button>' +
        '    </div>' +
        '  </div>' +
        '</div>';
    });

    itemsEl.innerHTML = html;

    /*
     * Subtotal is the pre-discount figure so the arithmetic on screen is
     * followable: subtotal − korting = totaal. Both rows previously showed
     * total_price, which was harmless while nothing was ever discounted but
     * meant a discount could only appear as two unexplained equal numbers.
     * With no discount the two are identical, so undiscounted carts look
     * exactly as they did.
     */
    var originalTotal = typeof data.original_total_price === 'number'
      ? data.original_total_price
      : data.total_price;

    subtotalEl.textContent = formatMoney(originalTotal);
    totalEl.textContent = formatMoney(data.total_price);
    renderDiscountRow(data);
    bindItemEvents();
  }

  function bindItemEvents() {
    var removeBtns = itemsEl.querySelectorAll('[data-remove-key]');
    removeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.removeKey;
        var itemEl = this.closest('.cart-drawer__item');
        if (itemEl) itemEl.classList.add('is-removing');
        /* changeItem surfaces the reason and refetches; undo the fade if it failed. */
        changeItem(key, 0).catch(function () {
          if (itemEl) itemEl.classList.remove('is-removing');
        });
      });
    });

    var qtyBtns = itemsEl.querySelectorAll('[data-qty-change]');
    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.qtyKey;
        var delta = parseInt(this.dataset.qtyChange, 10);
        var item = findItemByKey(key);
        if (!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        /*
         * Raising the quantity beyond available stock is the common failure
         * here. changeItem reports it and re-reads the cart, so the displayed
         * quantity snaps back to what Shopify actually holds.
         */
        changeItem(key, newQty).catch(function () { /* already reported */ });
      });
    });
  }

  function findItemByKey(key) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) return cart.items[i];
    }
    return null;
  }


  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        renderCart(data);
        return data;
      })
      .catch(function (err) {
        /*
         * Reading the cart failed — a network drop, or Shopify briefly
         * unavailable. Leave whatever is on screen alone rather than clearing
         * it; the cart itself is still safe on Shopify's side.
         */
        console.warn('[cart] Could not read the cart:', err);
        return cart;
      });
  }

  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (res) {
        /*
         * Read the body once, then decide. The previous version chained a
         * .catch() straight onto the .then() that threw, which swallowed the
         * error it had just created — so the shopper-facing reason from Shopify
         * ("You can only add 1 of ... to the cart") was always replaced by a
         * generic message.
         */
        return res.json()
          .catch(function () { return null; })
          .then(function (payload) {
            if (!res.ok) {
              var err = new Error(cartErrorMessage(payload));
              err.cartPayload = payload;
              err.status = res.status;
              throw err;
            }
            return payload;
          });
      })
      .then(function () {
        return fetchCart();
      });
  }

  function changeItem(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (res) {
        return res.json()
          .catch(function () { return null; })
          .then(function (payload) {
            if (!res.ok || !isCartPayload(payload)) {
              var err = new Error(cartErrorMessage(payload));
              err.cartPayload = payload;
              err.status = res.status;
              throw err;
            }
            return payload;
          });
      })
      .then(function (data) {
        renderCart(data);
        return data;
      })
      .catch(function (err) {
        /*
         * A rejected quantity change must not leave the drawer in a broken
         * state: tell the shopper, then re-read the real cart from Shopify so
         * what is on screen matches what is actually stored.
         */
        showCartError(err.message);
        return;
      });
  }


  function updateOverviewButtonState() {
    var forms = document.querySelectorAll('.product-overview__form, .lifestyle-product-overview__form');
    forms.forEach(function (form) {
      var btn = form.querySelector('.product-overview__add-to-cart, .lifestyle-product-overview__add-to-cart');
      var btnTextEl = form.querySelector('.hora-button-1-text');
      if (!btn || !btnTextEl) return;

      var checkedRadio = form.querySelector('input[name="id"]:checked');
      var hiddenId = form.querySelector('input[name="id"][type="hidden"]');
      var variantId = checkedRadio ? checkedRadio.value : (hiddenId ? hiddenId.value : null);

      if (!variantId) return;

      /* Check live cart first, fall back to localStorage for instant page-load state */
      var isInCart = false;
      if (cart && cart.items) {
        isInCart = cart.items.some(function (item) {
          return String(item.variant_id) === String(variantId);
        });
      } else {
        try {
          var stored = JSON.parse(localStorage.getItem(VARIANTS_KEY) || '[]');
          isInCart = stored.indexOf(String(variantId)) > -1;
        } catch (e) { }
      }

      var addedText = (window.HoraThemeSettings && window.HoraThemeSettings.cartAddedText) || 'Toegevoegd aan winkelwagen';
      var addText = (window.HoraThemeSettings && window.HoraThemeSettings.cartAddText) || 'Toevoegen aan winkelwagen';

      if (isInCart) {
        btn.classList.add('is-added');
        btn.setAttribute('data-cart-state', 'added');
        btnTextEl.textContent = addedText;
      } else {
        btn.classList.remove('is-added');
        btn.setAttribute('data-cart-state', 'idle');
        btnTextEl.textContent = addText;
      }
    });
  }

  /*
   * Inline message under a product page's add-to-cart button. Replaces any
   * previous message so they cannot stack up, and clears itself when the
   * shopper changes variant or tries again.
   */
  function showFormError(form, message) {
    if (!form) return;
    var existing = form.querySelector('.cart-form-error');
    if (existing) existing.remove();

    var el = document.createElement('p');
    el.className = 'cart-form-error';
    el.setAttribute('role', 'alert');
    el.textContent = message || CART_ERROR_FALLBACK;
    form.appendChild(el);

    window.setTimeout(function () {
      if (el.parentNode) el.remove();
    }, 8000);
  }

  function clearFormError(form) {
    if (!form) return;
    var existing = form.querySelector('.cart-form-error');
    if (existing) existing.remove();
  }

  function bindProductOverviewForm() {
    var forms = document.querySelectorAll('.product-overview__form, .lifestyle-product-overview__form');
    forms.forEach(function (form) {
      // Listen to radio/option changes to update button dynamically
      var radios = form.querySelectorAll('input[type="radio"][name="id"]');
      radios.forEach(function (radio) {
        radio.addEventListener('change', updateOverviewButtonState);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearFormError(form);
        var checkedRadio = form.querySelector('input[name="id"]:checked');
        var hiddenId = form.querySelector('input[name="id"][type="hidden"]');
        var variantId = checkedRadio ? checkedRadio.value : (hiddenId ? hiddenId.value : null);

        if (!variantId) {
          return;
        }

        var btn = form.querySelector('.product-overview__add-to-cart, .lifestyle-product-overview__add-to-cart');
        var qtyInput = form.querySelector('input[name="quantity"]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        // If already added, just open the drawer
        if (btn && btn.classList.contains('is-added')) {
          openDrawer();
          return;
        }

        if (btn) {
          btn.setAttribute('data-cart-state', 'loading');
          btn.style.opacity = '0.5';
          btn.style.pointerEvents = 'none';
          btn.disabled = true;
        }

        addToCart(parseInt(variantId, 10), quantity).then(function () {
          if (btn) {
            btn.setAttribute('data-cart-state', 'added');
            btn.style.opacity = '1';
            btn.style.pointerEvents = '';
            btn.disabled = false;
          }
          openDrawer();
        }).catch(function (err) {
          if (btn) {
            btn.setAttribute('data-cart-state', 'idle');
            btn.style.opacity = '1';
            btn.style.pointerEvents = '';
            btn.disabled = false;
          }
          /*
           * Previously the button simply reset and nothing was said, so a
           * rejected add looked like a dead button. Show the reason next to it —
           * inline rather than in the drawer, because the shopper is looking at
           * the product, and the drawer holds no new information.
           */
          showFormError(form, err.message);
        });
      });
    });
  }


  function bindProductCardButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-card__cart-btn, .lc-card__cart-btn, .lrec__cart-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var productUrl = btn.getAttribute('data-product-url');
      var currentState = btn.getAttribute('data-cart-state');
      var variantId = btn.getAttribute('data-variant-id');

      if (currentState === 'loading') return;

      if (currentState === 'added') {
        /* Remove from cart — match by variantId if available, fallback to url */
        if (cart && cart.items) {
          var matchItem = cart.items.find(function (item) {
            if (variantId) {
              return String(item.variant_id) === String(variantId);
            } else if (productUrl) {
              return basePath(item.url) === basePath(productUrl);
            }
            return false;
          });
          if (matchItem) {
            btn.setAttribute('data-cart-state', 'loading');
            /* changeItem already reports the reason; restore the button here. */
            changeItem(matchItem.key, 0).catch(function () {
              btn.setAttribute('data-cart-state', 'added');
            });
            return;
          }
        }
        btn.setAttribute('data-cart-state', 'idle');
        return;
      }

      /* idle → add to cart */
      if (!productUrl) return;
      btn.setAttribute('data-cart-state', 'loading');
      btn.disabled = true;

      if (variantId) {
        addToCart(variantId, 1)
          .then(function () {
            btn.setAttribute('data-cart-state', 'added');
            btn.disabled = false;
            openDrawer();
          })
          .catch(function (err) {
            btn.setAttribute('data-cart-state', 'idle');
            btn.disabled = false;
            /* Cards have no room for an inline message, so use the drawer. */
            showCartError(err.message);
          });
      } else {
        fetch(basePath(productUrl) + '.js')
          .then(function (res) { return res.json(); })
          .then(function (product) {
            var variant = product.variants && product.variants[0];
            if (!variant) throw new Error('No variant');
            return addToCart(variant.id, 1);
          })
          .then(function () {
            btn.setAttribute('data-cart-state', 'added');
            btn.disabled = false;
            openDrawer();
          })
          .catch(function (err) {
            btn.setAttribute('data-cart-state', 'idle');
            btn.disabled = false;
            showCartError(err.message);
          });
      }
    });
  }


  function syncCardButtonStates() {
    var cartUrls = cart
      ? (cart.items || []).map(function (item) { return basePath(item.url); })
      : getCartUrlsFromStorage();

    var cartVariantIds = cart
      ? (cart.items || []).map(function (item) { return String(item.variant_id); })
      : JSON.parse(localStorage.getItem(VARIANTS_KEY) || '[]');

    var allBtns = document.querySelectorAll('.product-card__cart-btn, .lc-card__cart-btn, .lrec__cart-btn');
    allBtns.forEach(function (btn) {
      var vid = btn.getAttribute('data-variant-id');
      if (vid) {
        btn.setAttribute('data-cart-state', cartVariantIds.indexOf(String(vid)) > -1 ? 'added' : 'idle');
      } else {
        var url = btn.getAttribute('data-product-url');
        if (url) {
          btn.setAttribute('data-cart-state', cartUrls.indexOf(basePath(url)) > -1 ? 'added' : 'idle');
        }
      }
    });

    if (typeof updateOverviewButtonState === 'function') {
      updateOverviewButtonState();
    }
  }


  window.HoraCart = {
    open: openDrawer,
    close: closeDrawer,
    fetch: fetchCart,
    add: addToCart,
    change: changeItem,
    syncButtons: syncCardButtonStates
  };


  /* Badge + overview button from localStorage immediately (before async fetch) */
  var storedCount = parseInt(localStorage.getItem(COUNT_KEY), 10) || 0;
  updateBadge(storedCount);
  updateOverviewButtonState();

  fetchCart();
  bindProductOverviewForm();
  bindProductCardButtons();

})();
